export const skuValidation_ = (dataArr, data) => {
  const isValid = dataArr.some((x, i) => {
    if (x.lineNo !== data.lineNo && x.status !== "Cancel") {
      const mln = x.mln === null ? "" : x.mln.trim();
      const mln_data = data.mln === null ? "" : data.mln.trim();
      //console.log(`${i}`,x.skuCode===data.skuCode && mln===mln_data && x.expiryDate===data.expiryDate)
      return x.skuCode === data.skuCode && mln === mln_data && x.expiryDate === data.expiryDate;
    }
  });
  //console.log(isValid)
  return isValid;
};

export const coSkuValidation_ = (dataArr, data) => {
  const isValid = dataArr.some((x, i) => {
    if (x.lineNo !== data.lineNo && x.status !== "Cancel") {
      console.log(x)
      const mln = x.mln === null ? "" : x.mln.trim();
      const mln_data = data.mln === null ? "" : data.mln.trim();
      const custOrdNbr = x.custOrdNbr === null ? "" : x.custOrdNbr.trim();
      const custOrdNbr_data = data.custOrdNbr === null ? "" : data.custOrdNbr.trim();
      return x.skuCode === data.skuCode && mln === mln_data && custOrdNbr === custOrdNbr_data;
    }
  });
  //console.log(isValid)
  return isValid;
};

export const recvSkuValidation_ = (dataArr, data) => {
  const isValid = dataArr.some((x, i) => {
    if (x.lineNo !== data.lineNo && x.status !== "Cancel") {
      console.log(x)
      const mln = x.mln === null ? "" : x.mln.trim();
      const mln_data = data.mln === null ? "" : data.mln.trim();
      const carton = x.cartonID === null ? "" : x.cartonID.trim();
      const carton_data = data.cartonID === null ? "" : data.cartonID.trim();
      return x.skuCode === data.skuCode && carton === carton_data && mln === mln_data && x.expiryDate === data.expiryDate;
    }
  });
  //console.log(isValid)
  return isValid;
};

export function updateDetail(details, data) {
  return details.map((detail) => {
    if (detail.lineNo === data.lineNo) return data;
    return detail;
  });
}

export function deleteDetail(details, data) {
  return details
    .filter((x) => x.lineNo !== data.lineNo)
    .map((detail, i) => ({ ...detail, lineNo: i + 1 }));
}

export function cancelDetail(details, data) {
  return details.map((detail) => {
    if (detail.lineNo === data.lineNo) detail.status = "Cancel";
    return detail;
  });
}

export function deleteNewDetail(details, data) {
  let lineNo = details.filter((x) => x.newItem === false).length;
  return details
    .filter((x) => x.lineNo !== data.lineNo)
    .map((detail) => {
      if (detail.newItem === false) return detail;
      return { ...detail, lineNo: ++lineNo };
    });
}

export function getTotalQuantity(details, property) {
  return details.reduce((total, detail) => {
    if (detail.status !== "Cancel") {
      total = detail[property] + total;
    }
    return total;
  }, 0);
}

export function getSplitDetailsTotalQuantity(details, property, lineProperty) {
  let lineNoArray = [];
  return details.reduce((total, detail) => {
    if (detail.status !== "Cancel") {
      if (!lineNoArray.includes(detail[lineProperty])) {
        lineNoArray.push(detail[lineProperty]);
        total = detail[property] + total;
      }
    }
    return total;
  }, 0);
}

export const serialValidation_ = (dataArr, data) => {
    const findDuplicates = (array) => {
      const counts = array.reduce((acc, item) => {
        acc[item.serialNumber] = (acc[item.serialNumber] || 0) + 1;
        return acc;
      }, {});
      return Object.keys(counts).filter(key => counts[key] > 1);
    };
  
    const selfDuplicates = findDuplicates(data.serialNumbers);
  
    if (selfDuplicates.length > 0) {
      return {
        isValid: true,
        type: "Single",
        serialNumbers: selfDuplicates,
        lineNos: null,
      };
    }
  
    const mainSerials = new Set(data.serialNumbers.map((item) => item.serialNumber));
    const duplicatesWithIds = {};

    dataArr
      .filter((x) => x.lineNo !== data.lineNo)
      .forEach(({ lineNo, serialNumbers }) => {
        serialNumbers.forEach((item) => {
          if (mainSerials.has(item.serialNumber)) {
            if (!duplicatesWithIds[item.serialNumber]) {
              duplicatesWithIds[item.serialNumber] = new Set();
            }
            duplicatesWithIds[item.serialNumber].add(lineNo);
          }
        });
      });

    const crossDuplicates = Object.keys(duplicatesWithIds);
    const lineNos = Array.from(
      new Set(crossDuplicates.flatMap((serial) => [...duplicatesWithIds[serial]]))
    );
  
    if (crossDuplicates.length > 0) {
      return {
        isValid: true,
        type: "Multiple",
        serialNumbers: crossDuplicates,
        lineNos: lineNos
      };
    }
  
    return { isValid: false, type: null, serialNumbers: [], lineNos: null };
};
